import GetProjectByIdRequestModelBase from '../_generated/modelBases/get-project-by-id-request-model-base';

export default class GetProjectByIdRequestModel extends GetProjectByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
